import React from 'react';
import { useCommon } from 'src/AppState/Common';
import { CampaignCreatorState } from 'src/domains/casino/webview/bonus-engine/campaign/CampaignCreator.state';
import { CampaignViewManager } from 'src/domains/casino/webview/bonus-engine/campaign/CampaignViewManager';
import { TabList, TabTrigger } from 'src/domains/common/components/tabs/tabs';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/AppState/AppState';

export type CampaignTabListPropsType = {
    campaignId?: string;
    campaignState: CampaignViewManager;
};

export const CampaignTabList = observer(
    'CampaignTabList',
    ({ campaignId, campaignState }: CampaignTabListPropsType): JSX.Element => {
        const { routerBackoffice } = useAppStateContext();
        const common = useCommon();
        const campaignCreatorState = CampaignCreatorState.get(common, campaignId);

        const list: Array<JSX.Element> = [];

        for (const viewItem of campaignState.campaignViewsList) {
            list.push(
                <TabTrigger
                    dataTest={viewItem.value}
                    key={viewItem.id}
                    onClick={() => campaignState.navigateToView(viewItem.value)}
                    active={viewItem.value === routerBackoffice.bonusCampaignParams?.view}
                    notifications={campaignCreatorState.campaignTabsErrors[viewItem.id]}
                    disabled={
                        viewItem.value === 'action-conditions' &&
                        campaignCreatorState.generalDetailsState.campaignType === 'promo-code'
                    }
                >
                    {viewItem.label}
                </TabTrigger>
            );
        }

        return <TabList>{list}</TabList>;
    }
);
